import $ from 'jquery';

$(function () {
    const researchTools = $('#research-tools');
    const researchToolsButton = $('#research-tools-button');

    if (researchTools.length > 0) {
        researchTools.on('change', function () {
            researchToolsButton.attr('href', $(this).val());
        });
    }

    //filter select
    const topicsSelect = $('select#topics-select');
    if (topicsSelect.length > 0) {
        topicsSelect.on('change', function () {
            if ($(this).val() && $(this).val() !== '') window.location = $(this).val();
        });
    }

    const readMoreHeader = $('.read-more-header');
    readMoreHeader.on('click', function() {
        $(this).next('.read-more-content').slideToggle();
    });
});
